export enum ProductStatuses {
    LOADING = "LOADING",
    READY = "READY",
    IN_QUEUE = "IN_QUEUE",
}
